import React, { useEffect, useState } from "react";
import Styles from "../../styles/preview/intro.module.scss";
import Img_logo from "../../assets/auth/LOGO.svg";
import { useNavigate } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import { useDispatch, useSelector } from "react-redux";
import { getScheduleGym } from "../../services";
import { io } from "socket.io-client";
import { updateIsPlayingState, updateProgressState } from "../../redux";
import { ApiEndpoints, LocalStorageKeys } from "../../core";
function secondsToHhmmss(totalSeconds) {
  if (totalSeconds == null) return "00:00:00";
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}

const Intro = () => {
  const { gymSchedule } = useSelector((state) => state.schedule);
  const [currentDate] = useState(new Date());
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [socket, setSocket] = useState(null);

  const todaySchedule = gymSchedule?.find((schedule) => {
    const scheduleDate = new Date(schedule.date);
    return scheduleDate.toDateString() === currentDate.toDateString();
  });

  const [remainingTime, setRemainingTime] = useState(null);

  useEffect(() => {
    getScheduleGym();
  }, []);
  useEffect(() => {
    if (!todaySchedule) return;
    const sessionId = todaySchedule._id;
    const gymToken = localStorage.getItem(LocalStorageKeys.gymToken);
    if (!gymToken) {
      console.error("Token not found in local storage");
      return;
    }
    const socketInstance = io(ApiEndpoints.serverURL, {
      reconnectionDelayMax: 10000,
      auth: {
        token: `Bearer ${gymToken}`,
      },
    });

    setSocket(socketInstance);


    socketInstance.on("preview_control_status", (data) => {
      console.log("Preview Control Status:", data);

      if (data.status === "play") {
        dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
      } else if (data.status === "pause") {
        dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));
      }
    });

    return () => {
      socketInstance.off("preview_control_status");
      socketInstance.disconnect();
    };
  }, [todaySchedule, dispatch]);
  useEffect(() => {
    if (todaySchedule && todaySchedule.session && remainingTime === null) {
      setRemainingTime(todaySchedule.session.warmupTime);
    }
  }, [todaySchedule, remainingTime]);

  useEffect(() => {
    if (remainingTime === null) return;
    if (remainingTime <= 0) {
      navigate(adminRoutes.video);
      return;
    }
    const timer = setInterval(() => {
      setRemainingTime((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [remainingTime, navigate]);

  return (
    <div className={Styles.intro_container}>
      <div className={Styles.logo}>
        <img src={Img_logo} alt="Training Room Logo" />
      </div>
      <h1 className={Styles.title}>
        {todaySchedule ? todaySchedule.session.name : "No Session Today"}
      </h1>
      <div className={Styles.warmup_container}>
        <div className={Styles.warmup_button}>Warm Up</div>
        <div className={Styles.warmup_button}>
          <svg
            className={Styles.icon}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 22C16.9706 22 21 17.9706 21 13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13C3 17.9706 7.02944 22 12 22Z"
              stroke="#F79328"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M5 19L3 21M19 19L21 21"
              stroke="#F79328"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 3.5697L19.5955 3.27195C20.4408 2.84932 20.7583 2.89769 21.4303 3.5697C22.1023 4.2417 22.1507 4.55924 21.728 5.4045L21.4303 6M5 3.5697L4.4045 3.27195C3.55924 2.84932 3.2417 2.89769 2.5697 3.5697C1.89769 4.2417 1.84932 4.55924 2.27195 5.4045L2.5697 6"
              stroke="#F79328"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M12 9.5V13.5L14 15.5"
              stroke="#F79328"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 3.5V2"
              stroke="#F79328"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 2H14"
              stroke="#F79328"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>{" "}
          {secondsToHhmmss(remainingTime)}
        </div>
      </div>
      <p className={Styles.coach_text}>COACH LED WARMUP</p>
      <div
        className={Styles.info_section}
        dangerouslySetInnerHTML={{
          __html: todaySchedule?.session?.details || "No Session Today",
        }}
      />
    </div>
  );
};

export default Intro;
